



















import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {DateTime} from 'luxon';
import vendorClaimDefault from '../../../../instance-defaults/vendorClaimDefault';
import VendorClaimTooltip from '@/components/Views/Vendor/VendorClaimTooltip.vue';
import {FeathersVuexFindAll} from '@/utils';
import {Mixins} from 'vue-property-decorator';
import UserRoleMixin from '@/mixins/UserRoleMixin.vue';
import {CLAIM_STATUS, multiNil, nil} from '@/common';
import VendorDialog from '@/components/Views/Vendor/VendorDialog.vue';
import VendorProfileDialog from '@/components/Views/Vendor/VendorProfileDialog.vue';
import VendorClaimList from '@/components/Views/Vendor/VendorClaimList.vue';
import bookingDefault from '@/instance-defaults/bookingDefault';
import BookingGoogleMapsMixin from '@/mixins/BookingGoogleMapsMixin.vue';
import CurrencyMixin from '@/mixins/CurrencyMixin.vue';
import ChangeBookingDialog from '@/components/Views/Dashboard/Booking/ChangeBookingDialog.vue';
import BookingCard from '@/components/Views/Dashboard/Booking/BookingCard.vue';
import BookingMetadataMixin from '@/mixins/BookingMetadataMixin.vue';
import ChangeBookingCheckInOut from '@/components/Views/Dashboard/Booking/ChangeBookingCheckInOut.vue';
import BookingCalculateCheckInOutMixin from '@/mixins/BookingCalculateCheckInOutMixin.vue';
import BookingActions from "@/components/Views/UI/BookingActions.vue";

@Component({
    components: {
        BookingActions,
        ChangeBookingCheckInOut,
        BookingCard, ChangeBookingDialog, VendorClaimList, VendorProfileDialog, VendorDialog, VendorClaimTooltip},
})
export default class BookingOverview extends Mixins(UserRoleMixin, BookingGoogleMapsMixin, CurrencyMixin, BookingMetadataMixin, BookingCalculateCheckInOutMixin) {
    @Prop({default: () => bookingDefault})
    public booking!: any;
    public mapHeight = 1000;
    public mapWidth = 500;
    public loading: boolean = true;
    public claim = null;
    public claims: any[] = [];

    public asGuest(guestAmount: number): string {
        return `${guestAmount} Guest${guestAmount > 1 ? 's' : ''}`;
    }
    public get bookingAddress() {
        if (multiNil(this, 'booking.address')) { return ''; }
        return this.booking.address;
    }

    public get orderUrl(){
        if(multiNil(this,"booking.order")) { return ''};
        return `/dashboard/orders/${this.booking.order}`;
    }

    public unmounted() {
        this.claim = null;
    }

    @Watch('booking')
    public onBookingChanged(value: any, oldValue: any) {
        this.fetchClaims();
    }

    public mounted() {
        this.fetchClaims();
    }
    public async fetchClaims() {

        this.loading = true;
        if (this.userIsVendor) {
            const {vendorModel} = this.$store.state.auth.user;
            this.claim = await this.getClaim(this.booking, vendorModel._id);
        } else {
            this.claims = await this.getClaims(this.booking);
        }
        this.loading = false;
    }
}
